import { useCallback, useMemo } from 'react';
import { planHasWatermark } from 'fym-shared/src/music24/watermarkUpsell';
import { useIsDemoAccount } from '../../../accountSelector/useIsDemoAccount';
import { useMusic24Plan } from '../../hooks/useMusic24Plan';
import { openWatermarkChoice, type WatermarkChoiceRequest } from './watermarkChoiceStore';

export interface WatermarkChoice {
  /** True on Free and the trial, for an owner and a member, when the artist is not the demo. */
  applies: boolean;
  /**
   * Runs a use of a file. When the file has the watermark and `applies`, the choice (design a2)
   * opens and its second row continues with one click; else the use continues at once. Returns
   * true when the choice opened.
   */
  gate: (hasWatermark: boolean, request: WatermarkChoiceRequest) => boolean;
}

/**
 * The rule of the choice modal (trial upsell spec 2026-10-13, D4): it opens on EACH click of
 * Download, share link, "Post it" and kit zip of a watermarked file. There is no "do not show again".
 */
export function useWatermarkChoice(): WatermarkChoice {
  const plan = useMusic24Plan();
  const isDemo = useIsDemoAccount();
  const applies = planHasWatermark(plan) && !isDemo;
  const gate = useCallback(
    (hasWatermark: boolean, request: WatermarkChoiceRequest) => {
      if (applies && hasWatermark) {
        openWatermarkChoice(request);
        return true;
      }
      request.onContinue?.();
      return false;
    },
    [applies]
  );
  return useMemo(() => ({ applies, gate }), [applies, gate]);
}
